
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    //import { Controlador as Chat } from '@view/a-chat/controlador';
    import novedades from './novedades.vue';
    import instalar from './instalar.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            novedades,

            instalar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorBase;

        @Prop( { default: false } ) public Movil: boolean;
        @Watch( 'Movil', { immediate: true })
        onMovil()
        {
            if ( this.Movil )
            {
                let root = document.documentElement;
                root.style.setProperty( '--toolbar-principal-height', "50px" );
                root.style.setProperty( '--toolbar-secundaria-height', "40px" );
            }
        }

        @Prop( { default: false } ) public NoExpandir: boolean;
        @Prop( { default: false } ) public ExpandirSiempre: boolean;
        @Prop( { default: false } ) public SinMenu: boolean;
        @Prop( { default: false } ) public SinToolbar: boolean;
        @Prop( { default: false } ) public BreakPoint: boolean;
        @Prop( { default: false } ) public SinAtras: boolean;
        @Prop( { default: true } ) public MostrarTitulo: boolean;
        @Prop( { default: true } ) public MostrarSubTitulo: boolean;
        @Prop( { default: true } ) public MostrarMenuOpciones: boolean;

        @Prop( { default: false } ) public SinOpcionesIzquierda: boolean;
        @Prop( { default: false } ) public SinOpcionesDerecha: boolean;
        @Prop( { default: false } ) public SinRed: boolean;
        @Prop( { default: false } ) public SinNotificaciones: boolean;
        @Prop( { default: false } ) public SinUsuario: boolean;

        @Prop( { default: false } ) public SinChat: boolean;
        @Watch( 'SinChat', { immediate: true } )
        onSinChat()
        {
            //Chat.ChatEmbebido = !this.SinChat;
        }
    }
